import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  CustomerModelRef,
  DivisionModelRef,
  NpmsDashboardStore,
  ProductModelRef,
  ProjectStatsModelRef,
  QuickLinksModelRef,
  RankingModelRef,
} from "../domain/dashboard.model";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";

//   export const fetchProjectStatsDatas = createAsyncThunk<ProjectStatsModelRef[],  { projectType: "npms" | "eci" | "custom" } 
// >("dashboard/fetchProjectStatsData", async ({projectType}) => {
//   const url = `${AppConstants.api}/dashboard/project-count?projectType=${projectType}`;
//   const response = await api.get<ApplicationResponse<any[]>>(
//     url
//   );
//   return response.data.data || [];
// });
export const fetchProjectStatsData = createAsyncThunk<
  ProjectStatsModelRef[], 
  { projectType: "npms" | "eci" | "custom"; plantIds: string[] }
>("dashboard/fetchProjectStatsData", async ({ projectType, plantIds }) => {
  const url = `${AppConstants.api}/dashboard/project-count?projectType=${projectType}`;
  const response = await api.post<ApplicationResponse<any[]>>(url, plantIds);
  return response.data.data || [];
});
  export const fetchUserProjectStatsData = createAsyncThunk<QuickLinksModelRef[],  { projectType: "npms" | "eci" | "custom",id: string } 
  >("dashboard/fetchUserProjectStatsData", async ({projectType,id}) => {
  const url = `${AppConstants.api}/dashboard/user-quick-count?projectType=${projectType}&id=${id}`;
  const response = await api.get<ApplicationResponse<ProjectStatsModelRef[]>>(
    url
  );
  return response.data.data || [];
  return [];
});



{/* customer chart data */}
//   export const fetchCustomerChartData = createAsyncThunk<CustomerModelRef[], { projectType: "npms" | "eci" | "custom" } >("dashboard/fetchCustomerChartData", async ({projectType}) => {
//   const url = `${AppConstants.api}/dashboard/project-customer-count?projectType=${projectType}`;
//   const response = await api.get<ApplicationResponse<CustomerModelRef[]>>(
//     url
//   );
//   return response.data.data || [];
// });
export const fetchCustomerChartData = createAsyncThunk<
  CustomerModelRef[], 
  { projectType: "npms" | "eci" | "custom"; plantIds: string[] }
>("dashboard/fetchCustomerChartData", async ({ projectType, plantIds }) => {
  const url = `${AppConstants.api}/dashboard/project-customer-count?projectType=${projectType}`;
  const response = await api.post<ApplicationResponse<CustomerModelRef[]>>(url, plantIds);
  return response.data.data || [];
});

{/* division chart data */}
// export const fetchDivisionChartData = createAsyncThunk<
//   DivisionModelRef[],
//   { projectType: "npms" | "eci" | "custom" } 
// >(
//   "dashboard/fetchDivisionChartData",
//   async ({ projectType }) => {
//     const url = `${AppConstants.api}/dashboard/product-division-count?projectType=${projectType}`;
//     const response = await api.get<ApplicationResponse<DivisionModelRef[]>>(url);
//     return response.data.data || [];
//   }
// );
export const fetchDivisionChartData = createAsyncThunk<
  DivisionModelRef[],
  { projectType: "npms" | "eci" | "custom"; plantIds: string[] }
>("dashboard/fetchDivisionChartData", async ({ projectType, plantIds }) => {
  const url = `${AppConstants.api}/dashboard/product-division-count?projectType=${projectType}`;
  const response = await api.post<ApplicationResponse<DivisionModelRef[]>>(url, plantIds);
  return response.data.data || [];
});


{/* ranking chart data */}
// export const fetchRankingChartData = createAsyncThunk<RankingModelRef[],  { projectType: "npms" | "eci" | "custom" } 
// >("dashboard/fetchRankingChartData", async ({projectType}) => {
//   const url = `${AppConstants.api}/dashboard/project-esc-ranking-count?projectType=${projectType}`;
//   const response = await api.get<ApplicationResponse<RankingModelRef[]>>(
//     url
//   );
//   return response.data.data || [];
// });
export const fetchRankingChartData = createAsyncThunk<
  RankingModelRef[], 
  { projectType: "npms" | "eci" | "custom"; plantIds: string[] }
>("dashboard/fetchRankingChartData", async ({ projectType, plantIds }) => {
  const url = `${AppConstants.api}/dashboard/project-esc-ranking-count?projectType=${projectType}`;
  const response = await api.post<ApplicationResponse<RankingModelRef[]>>(url, plantIds);
  return response.data.data || [];
});

{/* product chart data */}
// export const fetchProductChartData = createAsyncThunk<ProductModelRef[],  { projectType: "npms" | "eci" | "custom" } 
// >("dashboard/fetchProductChartData", async ({projectType}) => {
//   const url = `${AppConstants.api}/dashboard/project-product-count?projectType=${projectType}`;
//   const response = await api.get<ApplicationResponse<ProductModelRef[]>>(
//     url
//   );
//   return response.data.data || [];
// });

export const fetchProductChartData = createAsyncThunk<
  ProductModelRef[], 
  { projectType: "npms" | "eci" | "custom"; plantIds: string[] }
>("dashboard/fetchProductChartData", async ({ projectType, plantIds }) => {
  const url = `${AppConstants.api}/dashboard/project-product-count?projectType=${projectType}`;
  const response = await api.post<ApplicationResponse<ProductModelRef[]>>(url, plantIds);
  return response.data.data || [];
});







const npmsDashboardSlice = createSlice({
  name: "npmsDashboard",
  initialState: {
    divisionMinimal: {
      status: "loading",
      error: null,
      data: [],
    },
    customerMinimal: {
      status: "loading",
      error: null,
      data: [],
    },
    productMinimal: {
      status: "loading",
      error: null,
      data: [],
    },
    rankingMinimal: {
      status: "loading",
      error: null,
      data: [],
    },
    quickLinksMinimal: {
      status: "loading",
      error: null,
      data: [],
    },
    projectStatsMinimal: {
      status: "loading",
      error: null,
      data: [],
    },
    
  } as NpmsDashboardStore,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDivisionChartData.pending, (state, action) => {
        state.divisionMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchDivisionChartData.fulfilled, (state, action) => {
        state.divisionMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchDivisionChartData.rejected, (state, action) => {
        state.divisionMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      .addCase(fetchCustomerChartData.pending, (state, action) => {
        state.customerMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchCustomerChartData.fulfilled, (state, action) => {
        state.customerMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchCustomerChartData.rejected, (state, action) => {
        state.customerMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      .addCase(fetchProductChartData.pending, (state, action) => {
        state.productMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchProductChartData.fulfilled, (state, action) => {
        state.productMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchProductChartData.rejected, (state, action) => {
        state.productMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      .addCase(fetchRankingChartData.pending, (state, action) => {
        state.rankingMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchRankingChartData.fulfilled, (state, action) => {
        state.rankingMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchRankingChartData.rejected, (state, action) => {
        state.rankingMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      .addCase(fetchProjectStatsData.pending, (state, action) => {
        state.projectStatsMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchProjectStatsData.fulfilled, (state, action) => {
        state.projectStatsMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchProjectStatsData.rejected, (state, action) => {
        state.projectStatsMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      .addCase(fetchUserProjectStatsData.pending, (state, action) => {
        state.quickLinksMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchUserProjectStatsData.fulfilled, (state, action) => {
        state.quickLinksMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchUserProjectStatsData.rejected, (state, action) => {
        state.quickLinksMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      
      
  },
});

export default npmsDashboardSlice.reducer;
